import { makeActions } from 'redux/crudCreator/actions';

export const MODEL_NAME = 'subscriptions';
export const subscriptionsActions = makeActions(MODEL_NAME);

export const getAllSubscriptions = subscriptionsActions.getAll;
